module.exports = __webpack_public_path__ + "img/ar_icon.98461cc4.svg";